export var IGridComponent;
(function (IGridComponent) {
    /**
     * The tags are out of order. All tag numbers must be unique. When adding fields, also update the field below and the tag number.
     * See https:www.notion.so/faire/Protocol-Buffers-Protos-ba527d2f70c34ab983b8d0417c6a56ac#6a792ceb9d37498795a117e712b9e7e7 for details.
     * The last tag added was `responsiveTitle`. The next tag number is 13.
     */
    let GridDensity;
    (function (GridDensity) {
        GridDensity["GRID_DENSITY_UNKNOWN"] = "GRID_DENSITY_UNKNOWN";
        /**
         * @deprecated
         */
        GridDensity["FLEXIBLE"] = "FLEXIBLE";
        /**
         * Tiles per row given viewport: 3 -> 5 -> 8
         * @deprecated
         */
        GridDensity["DENSE"] = "DENSE";
        /**
         * Tiles per row given viewport: 2 -> 4 -> 6
         * @deprecated
         */
        GridDensity["STANDARD"] = "STANDARD";
        /**
         * Tiles per row given viewport: 1 -> 2 -> 3
         * @deprecated
         */
        GridDensity["SPARSE"] = "SPARSE";
    })(GridDensity = IGridComponent.GridDensity || (IGridComponent.GridDensity = {}));
    let IColumnLayout;
    (function (IColumnLayout) {
        /**
         * Return an instance of IColumnLayout with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IColumnLayout.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IColumnLayout = IGridComponent.IColumnLayout || (IGridComponent.IColumnLayout = {}));
    let IFixedColumnLayout;
    (function (IFixedColumnLayout) {
        /**
         * Return an instance of IFixedColumnLayout with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IFixedColumnLayout.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IFixedColumnLayout = IGridComponent.IFixedColumnLayout || (IGridComponent.IFixedColumnLayout = {}));
    let IResponsiveTruncationBehaviour;
    (function (IResponsiveTruncationBehaviour) {
        /**
         * Return an instance of IResponsiveTruncationBehaviour with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IResponsiveTruncationBehaviour.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IResponsiveTruncationBehaviour = IGridComponent.IResponsiveTruncationBehaviour || (IGridComponent.IResponsiveTruncationBehaviour = {}));
    let ITruncationBehaviour;
    (function (ITruncationBehaviour) {
        /**
         * Return an instance of ITruncationBehaviour with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        ITruncationBehaviour.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(ITruncationBehaviour = IGridComponent.ITruncationBehaviour || (IGridComponent.ITruncationBehaviour = {}));
    let IClippedTruncationBehaviour;
    (function (IClippedTruncationBehaviour) {
        /**
         * Return an instance of IClippedTruncationBehaviour with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IClippedTruncationBehaviour.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IClippedTruncationBehaviour = IGridComponent.IClippedTruncationBehaviour || (IGridComponent.IClippedTruncationBehaviour = {}));
    let IExpandTruncationBehaviour;
    (function (IExpandTruncationBehaviour) {
        /**
         * Return an instance of IExpandTruncationBehaviour with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IExpandTruncationBehaviour.build = (partial) => (Object.assign({ on_click: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(IExpandTruncationBehaviour = IGridComponent.IExpandTruncationBehaviour || (IGridComponent.IExpandTruncationBehaviour = {}));
    let ILogTileBatchView;
    (function (ILogTileBatchView) {
        /**
         * Return an instance of ILogTileBatchView with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        ILogTileBatchView.build = (partial) => (Object.assign({ parameters: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(ILogTileBatchView = IGridComponent.ILogTileBatchView || (IGridComponent.ILogTileBatchView = {}));
    /**
     * Return an instance of IGridComponent with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IGridComponent.build = (partial) => (Object.assign({ tiles: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IGridComponent || (IGridComponent = {}));
